import { BackendErrorCode } from '@/modules/common/api/errors';

import { BillSyncErrorReason } from '../types';

export const BILL_SYNC_ERROR_I18N_KEYS: Record<number, string> = {
  [BackendErrorCode.ENTITY_SYNC_INTERNAL_ERROR]: 'syncError.internal',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_AUTHENTICATION_ERROR]: 'syncError.authentication',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_PERMISSION_ERROR]: 'syncError.permission',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_SERVICE_UNAVAILABLE]: 'syncError.serviceUnavailable',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_RATE_LIMIT_ERROR]: 'syncError.rateLimit',
  [BackendErrorCode.ENTITY_SYNC_INTEGRATION_GENERAL_ERROR]: 'syncError.general',
};

export const BILL_SYNC_ERROR_REASON_I18N_KEYS: Record<BillSyncErrorReason, string> = {
  [BillSyncErrorReason.VendorNotAvailable]: 'reason.vendorNotAvailable',
  [BillSyncErrorReason.ProjectNotAvailable]: 'reason.projectNotAvailable',
  [BillSyncErrorReason.ProductOrServiceNotAvailable]: 'reason.productOrServiceNotAvailable',
  [BillSyncErrorReason.VendorCurrencyMismatch]: 'reason.vendorCurrencyMismatch',
  [BillSyncErrorReason.CurrencyNotEnabled]: 'reason.currencyNotEnabled',
  [BillSyncErrorReason.AccountingPeriodClosed]: 'reason.accountingPeriodClosed',
  [BillSyncErrorReason.NegativeLineAmountNotAllowed]: 'reason.negativeLineAmountNotAllowed',
  [BillSyncErrorReason.LineDescriptionTooLong]: 'reason.lineDescriptionTooLong',
  [BillSyncErrorReason.TransactionDateNotAllowed]: 'reason.transactionDateNotAllowed',
  [BillSyncErrorReason.LineValueOutOfRange]: 'reason.lineValueOutOfRange',
  [BillSyncErrorReason.DataRejected]: 'reason.dataRejected',
};
